import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Page } from '@dixa/lib-shared-habla';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { config } from 'lib-shared-backend-config';
import { BillingPaymentMethodsSection } from './components/billingPaymentMethodsSection/billingPaymentMethodsSection';
import { BillingInformationSection } from './components/billlingInformationSection/billingInformationSection';
const stripePromise = loadStripe(config.sdk.stripe);
export const SettingsBillingView = () => {
    return (_jsx(Elements, Object.assign({ stripe: stripePromise }, { children: _jsxs(Page, { children: [_jsx(Page.Head, { title: "Billing" }), _jsxs(Page.Body, { children: [_jsx(BillingInformationSection, {}), _jsx(BillingPaymentMethodsSection, {})] })] }) })));
};
